import axios from 'axios';
import config from 'shared/config';
import setBaseRequest from 'shared/utils/setBaseRequest';
import qs from 'qs';
import { asyncStart, asyncSuccess, asyncError } from 'redux/domain/AsyncStatus/actions';
import { batchActions } from 'redux-batched-actions';
import { createNotification } from 'redux/domain/Notifications/creators';
import {
	setCustomerId,
	setResultCode,
	setPreviousApplicationValues,
} from 'redux/domain/TermsAndConditions/creators';
import keyPath from './keyPath';

const submitCA = (
	asyncId,
	submitValues,
	TermsAndConditionsSubmitErrorNotificationText,
) => async dispatch => {
	const asyncKeyPath = keyPath(asyncId);
	const cancellationSource = axios.CancelToken.source();
	// begin sumbmission by setting async status and storing the cancellation source
	dispatch(asyncStart(asyncKeyPath, cancellationSource));
	let response;
	// submit
	try {
		response = await axios.post(
			`${config.ESTORIS_BASE_PATH}/SubmitFRCreditApp`,
			qs.stringify(submitValues),
			setBaseRequest({}, cancellationSource.token),
		);
		// update sync status
		dispatch(
			batchActions([
				setCustomerId(response.data.customerId),
				setResultCode(response.data.resultCode),
				asyncSuccess(asyncKeyPath),
				setPreviousApplicationValues(submitValues),
			]),
		);
	} catch (error) {
		if (!axios.isCancel(error)) {
			// fetch completed in error
			dispatch(
				batchActions([
					asyncError(asyncKeyPath, error),
					createNotification(TermsAndConditionsSubmitErrorNotificationText),
				]),
			);
			throw error;
		}
	}
	return response;
};

export default submitCA;
